import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  TextField,
  Button,
  Container,
  Typography,
  Box,
  CircularProgress,
  InputAdornment,
  Paper,
  Link,
  Alert,
} from "@mui/material";
import { Phone, ArrowBack } from "@mui/icons-material";
import { sendForgotPasswordSms } from "../services/api";
import logo from "../assets/logos/logo.png";
import loginIcon from "../assets/icons/loginIcon.png";
import "./Login.css";
import { set } from "react-hook-form";

const ForgotPassword = () => {
  const navigate = useNavigate();

  const [phone, setPhone] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const validatePhone = (value) => {
    if (!value) {
      setPhoneError("Telefon numarası alanı zorunludur.");
      return false;
    }
    const isValid = /^5\d{9}$/.test(value);
    setPhoneError(
      isValid ? "" : "Geçerli bir telefon numarası girin (Örn: 5321234567)"
    );
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    const isPhoneValid = validatePhone(phone);
    if (!isPhoneValid) return;

    setLoading(true);
    try {
      const data = {
        TELEFON: `0${phone}`,
      };

      await sendForgotPasswordSms(data);
      setSuccess(
        "SMS kodu gönderildi. Kod doğrulama sayfasına yönlendiriliyorsunuz..."
      );

      setTimeout(() => {
        navigate("/forgot-password-verify", { state: { phone: `0${phone}` } });
      }, 2000);
    } catch (error) {
      console.error("SMS gönderme hatası:", error);

      if (error.response?.status === 400) {
        setError("Bu telefon numarasına kayıtlı aktif bir kullanıcı yoktur.");
      } else {
        setError(
          error.response?.data?.message ||
            "SMS gönderilirken bir hata oluştu. Lütfen tekrar deneyin."
        );
      }
    } finally {
      setLoading(false);
    }
  };

  const handleBackToLogin = () => {
    navigate("/login");
  };

  return (
    <div className="login-page-container">
      <div className="left-panel">
        <Container
          component={Paper}
          elevation={6}
          className="login-card"
          maxWidth={false}
        >
          <Box className="login-header">
            <img src={logo} alt="eKumes Logo" className="login-logo" />
          </Box>

          <Typography variant="h4" className="login-title" gutterBottom>
            Şifremi Unuttum
          </Typography>

          <Typography
            variant="body2"
            sx={{ mb: 3, color: "#666", textAlign: "center" }}
          >
            Telefon numaranızı girin, size SMS ile doğrulama kodu göndereceğiz.
          </Typography>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          {success && (
            <Alert severity="success" sx={{ mb: 2 }}>
              {success}
            </Alert>
          )}

          <Box component="form" onSubmit={handleSubmit} className="login-form">
            <Typography className="input-label">Telefon Numarası</Typography>
            <TextField
              fullWidth
              placeholder="5XXXXXXXXX"
              value={phone}
              onChange={(e) => setPhone(e.target.value.replace(/\D/g, ""))}
              onBlur={(e) => validatePhone(e.target.value)}
              error={!!phoneError}
              helperText={phoneError}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Phone className="input-icon phone-icon" />
                  </InputAdornment>
                ),
              }}
              inputProps={{ maxLength: 10 }}
              type="tel"
              className="login-input"
            />

            <Button
              variant="contained"
              type="submit"
              disabled={loading}
              className="login-button"
              fullWidth
              sx={{ mt: 2 }}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Kod Gönder"
              )}
            </Button>

            <Box
              className="forgot-password-container"
              sx={{ mt: 2, textAlign: "center" }}
            >
              <Link
                component="button"
                variant="body2"
                onClick={handleBackToLogin}
                className="forgot-password-link"
                sx={{
                  color: "#1976d2",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                <ArrowBack sx={{ fontSize: 16, mr: 0.5 }} />
                Giriş sayfasına dön
              </Link>
            </Box>
          </Box>
        </Container>
      </div>

      <div className="right-panel">
        <div className="image-frame">
          <img
            src={loginIcon}
            alt="Login Visual"
            className="side-image"
            draggable="false"
          />
          <div className="welcome-overlay">
            <Typography variant="h3" className="welcome-text">
              Şifre Sıfırlama
            </Typography>
            <Typography variant="subtitle1" className="welcome-subtext">
              Telefon numaranızı girin
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
